import { createFileRoute } from "@tanstack/react-router";
import { permanentRedirect } from "@/lib/routeRedirect";

// Legacy URL: renamed to /admin/job-boards; answered with a real 301.
export const Route = createFileRoute("/_admin/admin/job-syndication")({
  beforeLoad: permanentRedirect("/admin/job-boards"),
});
